import {
    FETCH_CATEGORIA,
    FETCH_LOADING,
    FETCH_ERROR,
} from "../types/types";


const initialState = {
    Categoria: [],
    Error: "",
    Loading: false,
}


export const categoriaReducer = (state = initialState,action)=>{
    switch(action.type){
        case FETCH_CATEGORIA:
            return{
                ...state,Categoria:action.payload,Loading: false
            }
        case FETCH_LOADING:
            return{
                ...state,Loading:true
            }
        case FETCH_ERROR:
            return{
                ...state,Error:action.payload
            }        
            default:
                return state;
    }
}